import React, {Component} from 'react';
import Calendar from './Calendar';
import PrimaryBox from "@assets/js/booking_engine/components/PrimaryBox";
import Loading from './Loading';
import CounterMultiple from './CounterMultiple';
import {BOOKING_ENGINE_URI_PREFIX} from '../constants/index';
import {getApartmentIdFromURL, getBookingEngineTranslations, getBookingPeriod, showPriceWithCurrency} from '../../functions/helpers';
import {useFetch} from "@assets/js/functions/helpers";
import {CONFIG} from '../config'
import Details from "./Details/Details";
import DetailsGroup from "./Details/DetailsGroup";
import DetailsItem from "./Details/DetailsItem";
import history from 'history/browser';
import IcoBlik from  "../../../../../public_html/img/payment_icons/ico-blik.svg";
import IcoVisa from  "../../../../../public_html/img/payment_icons/ico-visa.svg";
import IcoMasterCard from  "../../../../../public_html/img/payment_icons/ico-mc.svg";
import IcoPayPal from  "../../../../../public_html/img/payment_icons/ico-paypal.svg";
import IcoGooglePay from  "../../../../../public_html/img/payment_icons/ico-g-pay.svg";
import IcoApplePay from  "../../../../../public_html/img/payment_icons/ico-jablko.svg";
// import IcoTpayRaty from  "../../../../../public_html/img/payment_icons/ico-tpayraty.svg";
import IcoPayPo from  "../../../../../public_html/img/payment_icons/ico-paypo.svg";
import IcoKlarna from  "../../../../../public_html/img/payment_icons/ico-klarna.svg";
import IcoBankTransfer from  "../../../../../public_html/img/payment_icons/ico-przelew-tradycyjny.svg";
import IcoBankTransferPl from  "../../../../../public_html/img/payment_icons/ico-bank-przelew.svg";
import IcoMyBenefit from  "../../../../../public_html/img/payment_icons/ico-mybenefit-vector-logo.svg";
// import IcoBlikPP from  "../../../../../public_html/img/payment_icons/ico-blik-pp.svg";
import Switch from "../../elements/components/form/Switch";
import { round } from '@turf/helpers'
import CashbackDisplay from '../../search-trip-offer/components/OfferConfigForm/fields/CashbackDisplay';

const locale = document.getElementById('root').dataset.locale;
const queryString = require('query-string');
const queryParams = queryString.parse(window.location.search, {arrayFormat: 'bracket'});
const translations = getBookingEngineTranslations();
const num_guests = queryParams.guests ? queryParams.guests : 2;
const COUNTERS_LIST_DEFAULT = [
    {
        key: 'adults',
        value: 2,
        title: translations['counter-option-1'],
        subtitle: translations['counter-description-1'],
    },
    {
        key: 'children',
        value: 0,
        title: translations['counter-option-2'],
        subtitle: translations['counter-description-2'],
    },
    {
        key: 'baby',
        value: 0,
        title: translations['counter-option-3'],
        subtitle: translations['counter-description-3'],
    },
];

export default class BookingCalendar extends Component {
    state = {
        isGuestsNumberValid: null,
        post_id: null,
        liteMode: false,
        focusedInput: null,
        isLoading: false,
        dateSelected: false,
        result_avaibility: false,
        minimumCleaningPrice: null,
        counterValuesCrucials: null,
        unavailableReason: null,
        nightsTotal: null,
        priceTotal: null,
        earnedCashbackAmount: null,
        isSecondCalculation: false,
        from: null,
        to: null,
        daysOccupied: null,
        showNewsletterForm: false,
        newsletterFormData: {
            lang: locale,
            formId: "831de8b4-0243-44de-a008-b1772cd8a4c8",
            sm_form_email: "",
            sm_form_country: locale,
            sm_form_consent_id_4435_REGULAMINY_1: true,
            sm_form_consent_name_4435_REGULAMINY_1: false,
            sm_form_consent_id_4437_ZGODA_2_VC: true,
            sm_form_consent_name_4437_ZGODA_2_VC: false
        },
        newsletterFormResult: "",
        requiredServices: [],
    };

    calendarRef = React.createRef();

    componentDidMount() {
        const {initData: {currentApartmentId, sessionApartmentId, lite}} = this.props

        const initCalendar = new Promise(() => {
            this.syncAvailability()
        })

        initCalendar.then(this.setApartmentId())
            .then(this.getInitialBookingDate())

        initCalendar.catch(this.setApartmentId())

        if (sessionApartmentId !== '' && (currentApartmentId !== sessionApartmentId)) {
            this.setCalculationUrls()
        }

        const initialData = this.getDefaultCounters()

        const counterValuesCrucials = this.convertCounterValuesToCrucials(initialData)

        this.setState({
            counterValuesCrucials,
            isGuestsNumberValid: this.hasValidGuestsNumber(initialData),
            url: this.generateCalculationUrl(),
            liteMode: lite,
        })
    }

    componentDidUpdate() {
        let shouldSetForceUpdate = false;

        if (this.state.from || this.state.to) {
            shouldSetForceUpdate = this.isTheSameApartmentWithActiveCalculationAndDateChanged()
        }

        if (shouldSetForceUpdate) {
            this.setCalculationUrls()
        }
    }

    syncAvailability = () => {
        const {initData: {currentApartmentId}} = this.props

        useFetch(
            CONFIG.syncAvailability + currentApartmentId,
            null,
            payload => {
                const {daysOccupied} = payload

                this.setState({
                    daysOccupied
                })
            }
        )
    }

    getInitialBookingDate = () => {
        const {initData: {currentApartmentId, sessionApartmentId}} = this.props
        const from = queryParams.check_in;
        const to = queryParams.check_out;

        if (currentApartmentId === sessionApartmentId) {
            useFetch(
                CONFIG.getActiveCalculation,
                null,
                activeCalculation => {
                    const {check_in, check_out} = activeCalculation

                    this.setState({
                            from: check_in,
                            to: check_out
                        },
                    )
                }
            )
        } else {
            this.setState({from, to})
        }
    }

    isTheSameApartmentWithActiveCalculationAndDateChanged = () => {
        const calendarState = this.calendarRef.current.state;
        const activeCalculationCheckIn = new Date(this.state.from).toLocaleDateString()
        const activeCalculationCheckOut = new Date(this.state.to).toLocaleDateString()
        const calendarFrom = calendarState.from ? calendarState.from.toLocaleDateString() : null
        const calendarTo = calendarState.to ? calendarState.to.toLocaleDateString() : null
        const {initData: {currentApartmentId, sessionApartmentId}} = this.props

        if (
            activeCalculationCheckIn === calendarFrom
            && activeCalculationCheckOut === calendarTo
        ) {
            return false
        }

        return calendarFrom !== null
            && calendarTo !== null
            && currentApartmentId === sessionApartmentId
            && activeCalculationCheckIn !== '1.01.1970'
            && activeCalculationCheckIn !== '01.01.1970'
            && !this.state.isSecondCalculation
    }

    forceRedirect = () => {
        if (!this.state.isGuestsNumberValid) {
            return
        }

        const currentApartmentCalculationUrl = this.generateCalculationUrl()

        fetch(CONFIG.clearCart)
            .then(() => {
                window.location.replace(currentApartmentCalculationUrl)
            })
            .catch(err => alert(err))
    }

    handleDateSelected = isDateSelected => {
        if (!isDateSelected) return;

        const {post_id} = this.state;
        const {from, to} = this.calendarRef.current.state;

        if (!from || !to) return;

        const {adults, children, baby, guests} = queryParams
        const params = {
            post_id: post_id,
            check_in: from ? from.toISOString().slice(0, 10) : null,
            check_out: to ? to.toISOString().slice(0, 10) : null,
            adult: guests || adults || 1,
            children,
            baby,
        }

        this.setState({isLoading: true})

        fetch(
            CONFIG.getAvailability,
            {
                method: 'post',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params),
            },
        )
            .then(res => {
                return res.json()
            })
            .then(availability => {
                this.setCalendarDate(availability)
            })
            .catch(err => {
                alert(translations['error-message'] + err)
            })

        //todo set window location url
        let locationQueryParams = {
          ...queryParams,
          ...{'check_in':from.toISOString().slice(0, 10),'check_out': to.toISOString().slice(0, 10), 'guests': guests}
        }
        let locationHistoryUrl = this.generateLocationHistoryUrl(locationQueryParams);
        history.replace(locationHistoryUrl, { some: 'state', ...locationQueryParams });
    }

    setCalendarDate = availability => {
        const { liteMode } = this.state;

        if (availability.status) {
            const availableOffer = availability.rate_plans.non_refundable !== undefined ?
                availability.rate_plans.non_refundable : Object.values(availability.rate_plans)[0];

            let cleaningServicePrice = { price: 0 };
            let requiredServicesPrice = 0;
            let requiredServices = [];

            cleaningServicePrice = availability.supplements.map(supplementsCategory =>
                supplementsCategory.supplements.filter(supplement => {
                        if (CONFIG.YP_CLEANING_SUPPLEMENTS.includes(supplement.IdSupplementYp)) {
                            return supplement
                        }
                    }
                )[0]
            )[0];

            availability.supplements.forEach(supplementsCategory =>
                supplementsCategory.supplements.forEach(supplement => {
                        if (CONFIG.YP_REQUIRED_SUPPLEMENTS.includes(supplement.IdSupplementYp)) {
                            requiredServicesPrice += supplement.price;
                            requiredServices.push(supplement);
                        }
                    }
                )
            )

            if (requiredServices.length > 0) {
                this.state.requiredServices = requiredServices;
            }

            if (typeof cleaningServicePrice === 'undefined') {
                cleaningServicePrice = {};
                cleaningServicePrice.price = 0;

                /*alert(translations['error-message'] + ' missing cleaning price')
                this.setState({
                    isLoading: false,
                })
                return;*/
            }

            const bookingNights = availableOffer.DailyPrices.DailyPrice.length !== undefined ? availableOffer.DailyPrices.DailyPrice.length : [availableOffer.DailyPrices.DailyPrice].length;
            const nightsTotal = getBookingPeriod(bookingNights, translations)
            const earnedCashbackAmount = round(parseFloat(availableOffer.RoomPrice)/100, 2)
            const priceTotal = this.calculateTotalPrice(
                availableOffer.RoomPrice,
                cleaningServicePrice.price,
                requiredServicesPrice,
                bookingNights
            );

            this.setState({
                priceTotal,
                earnedCashbackAmount,
                nightsTotal,
                isLoading: false,
                unavailableReason: null,
                roomPrice: availableOffer.RoomPrice ? availableOffer.RoomPrice : '',
                ratePlans: availability.rate_plans,
                minimumCleaningPrice: cleaningServicePrice.price,
            })
        } else {
            const unavailableReason = availability.message

            this.setState({
                priceTotal: null,
                nightsTotal: null,
                isLoading: false,
                unavailableReason,
                ratePlans: availability.rate_plans,
                minimumCleaningPrice: null
            })
        }
    }

    calculateTotalPrice = (
        roomPrice,
        cleaningPrice,
        requiredServicesPrice,
        nights
    ) => {
        const adults = Number(queryParams.adults) || 0;
        const children = Number(queryParams.children) || 0;
        const baby = Number(queryParams.baby) || 0;

        const participantsOfNights = (adults + children + baby) * nights;
        const requiredServicesTotalPrice = Number(requiredServicesPrice) * participantsOfNights;

        const total = parseFloat(roomPrice) +
            parseFloat(cleaningPrice) +
            requiredServicesTotalPrice;

        return total.toFixed(2);
    }

    setApartmentId = () => {
        const post_id = getApartmentIdFromURL();

        this.setState({
            post_id,
        })
    }

    generateCalculationUrl = (inheritUrl) => {
        if (!this.calendarRef.current) return;

        const calendarState = this.calendarRef.current.state;
        let counterValuesCrucials = this.state.counterValuesCrucials
        const {from, to} = this.calendarRef.current.state;
        const queryData = {
            check_in: from ? calendarState.from.toISOString().slice(0, 10) : null,
            check_out: to ? calendarState.to.toISOString().slice(0, 10) : null,
            ...counterValuesCrucials,
        }
        const query = queryString.stringify(queryData, {sort: false});

        return inheritUrl !== undefined ?
          `${inheritUrl}?${query}` :
          `${window.location.origin}/${BOOKING_ENGINE_URI_PREFIX}${window.location.pathname}?${query}`;
    }

    generateLocationHistoryUrl = (queryData) => {
        const query = queryString.stringify(queryData, {sort: false});

        return `${window.location.pathname}?${query}`;
    }

    convertCounterValuesToCrucials = (counterValues) => {
        return counterValues.reduce(function (obj, item) {
            obj[item.key] = item.value;
            return obj;
        }, {});
    }

    getGuestsTotal = counters => {
        return counters.reduce(
            (total, counter) => {
                if (counter.key === 'baby') {
                    return total
                }

                return total + (parseInt(counter.value, 10) || 0)
            },
            0
        )
    }

    hasValidGuestsNumber = counters => {
        const {
            guestsLimit,
            adultsLimit,
            kidsLimit,
            babiesLimit,
        } = this.props.initData

        const counterLimits = {
            adults: adultsLimit,
            children: kidsLimit,
            baby: babiesLimit,
        }

        const hasInvalidCounter = counters.some(counter => {
            const value = Number(counter.value)
            const minLimit = counter.key === 'adults' ? 1 : 0
            const maxLimit = counterLimits[counter.key]

            return (
                !Number.isInteger(value) ||
                value < minLimit ||
                value > maxLimit
            )
        })

        if (hasInvalidCounter) {
            return false
        }

        return this.getGuestsTotal(counters) <= guestsLimit
    }

    handleCounterChange = changedCounterValues => {
        const counterValuesCrucials = this.convertCounterValuesToCrucials(
            changedCounterValues
        )

        this.setState({
            counterValuesCrucials,
            isGuestsNumberValid: this.hasValidGuestsNumber(
                changedCounterValues
            ),
        })
    }

    handleSwitcherChecked = (checked) => {
        this.setState({
            showNewsletterForm: checked
        });
    }

    handleNewsletterEmailChange = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            newsletterFormData: {
                ...prevState.newsletterFormData,
                [name]: value
            }
        }));
    }

    handleNewsletterCheckboxChange = (event) => {
        const { name, checked } = event.target;
        this.setState((prevState) => ({
            newsletterFormData: {
                ...prevState.newsletterFormData,
                [name]: checked
            }
        }));
    }

    handleNewsletterSubmit = (event) => {
        event.preventDefault();

        const updatedFormData = {};
        for (const key in this.state.newsletterFormData) {
            if (Object.hasOwnProperty.call(this.state.newsletterFormData, key)) {
                const updatedKey = key.replace(/_/g, "-");
                updatedFormData[updatedKey] = this.state.newsletterFormData[key];
            }
        }

        $.ajax({
            type: 'POST',
            url: '/newsletter/forward-to-sales-manago',
            data: updatedFormData,
            success: (message) => {
                this.setState({
                    showNewsletterForm: false,
                    newsletterFormResult: message
                });
            },
            error: function (error) {
                alert("Wystapil blad.");
            }
        });
    };

    handleClear = () => {
        this.setState({
            unavailableReason: null,
            dateSelected: false,
            nightsTotal: null,
            priceTotal: null,
            minimumCleaningPrice: null,
        })
    }

    getDefaultCounters = () => {
        const {adults, children, baby} = queryParams
        const queryParamsGuests = [
            {
                key: 'adults',
                value: adults,
            },
            {
                key: 'children',
                value: children,
            },
            {
                key: 'baby',
                value: baby,
            }
        ]

        return COUNTERS_LIST_DEFAULT.map(defaultCounter => {
            const inheritedCounter = queryParamsGuests.filter(guest => guest.key === defaultCounter.key)[0]

            return inheritedCounter.value ?
                {
                    ...defaultCounter,
                    ...inheritedCounter
                }
                :
                defaultCounter
        })
    }

    setCalculationUrls() {
        const calculation_id = document.getElementById('root').dataset.sessionApartmentId

        useFetch(
            CONFIG.getActiveCalculationUrl,
            {calculation_id},
            url => {
                this.setState({
                    calculationUrl: this.generateCalculationUrl(),
                    activeCalculationUrl: url,
                    isSecondCalculation: true,
                })
            }
        )
    }

    getRoomCleaningPrice() {
        const {minimumCleaningPrice} = this.state;

        let price = 0;

        if (minimumCleaningPrice !== null) {
            price = minimumCleaningPrice;
        }

        return price + " PLN";
    }

    getPriceName = () => {
        const {ratePlans} = this.state

        if (Object.keys(ratePlans).length > 1) {
            return `${translations['calendar-details-price']} ${translations['calendar-details-price-1']}`
        }

        return translations['calendar-details-price']
    }

    renderActionButton = () => {
        const {
            activeCalculationUrl,
            requiredServices,
            isGuestsNumberValid,
        } = this.state

        const canContinue = isGuestsNumberValid === true

        const priceTotal = showPriceWithCurrency(this.state.priceTotal);

        return (
            <div className={!canContinue ? 'disabled' : ''}>
                {this.state.nightsTotal && (
                    <div>
                        <div style={{ marginTop: '10px' }}>
                            <Details>
                                <DetailsGroup>
                                    <DetailsItem
                                        name={translations['calendar-details-cleaning']}
                                        info={this.getRoomCleaningPrice().replace('.', ',')}
                                    />
                                    {requiredServices.map(reqService => (
                                        <DetailsItem
                                            name={translations[`supplements-${reqService.kind_id}-require`]}
                                            info={`${reqService.price.replace('.', ',')} PLN |${translations['per_person']}|${translations['day']}`}
                                        />
                                    )) }
                                </DetailsGroup>
                                <DetailsGroup>
                                    <DetailsItem
                                        nameClass="item__name--price-after"
                                        infoClass="item__info--price-after"
                                        name={this.getPriceName()}
                                        info={(Number(this.state.priceTotal) || 0).toFixed(2).replace('.', ',') + ' PLN'}
                                    ></DetailsItem>
                                    <DetailsItem
                                        nameClass="item__name--price-before"
                                        name={translations['calendar-details-price-2']}
                                        infoClass="nights-count-calendar"
                                        info={translations['for'] + ' ' + this.state.nightsTotal}
                                    />
                                </DetailsGroup>
                            </Details>
                        </div>
                        <CashbackDisplay
                            price={this.state.earnedCashbackAmount}
                            title={translations['cashback-widget']}
                            style={{ marginBottom: '14px' }}
                        />
                        <div className="newsletter-box">
                            <div className="filter-switch__wrapper">
                                <Switch
                                    uniqueID="showNewsletterTrigger"
                                    onChange={this.handleSwitcherChecked}
                                    onChecked={this.handleSwitcherChecked}
                                    checked={this.state.showNewsletterForm}
                                />
                                <span>{translations['newsletter-save-label']}</span>
                            </div>

                            {this.state.showNewsletterForm && (
                                <form onSubmit={this.handleNewsletterSubmit}>
                                    <input
                                        className="form-field email"
                                        name="sm_form_email"
                                        placeholder="E-mail"
                                        required
                                        type="email"
                                        value={this.state.newsletterFormData.sm_form_email}
                                        onChange={this.handleNewsletterEmailChange}
                                    />

                                    <div className="tickbox">
                                        <div className="left">
                                            <input
                                                type="checkbox"
                                                required
                                                name="sm_form_consent_name_4435_REGULAMINY_1"
                                                checked={
                                                    this.state.newsletterFormData.sm_form_consent_name_4435_REGULAMINY_1
                                                }
                                                onChange={this.handleNewsletterCheckboxChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="right">
                                            <span>
                                                {translations['i_accept_the']}{' '}
                                                <a
                                                    href="/regulamin-swiadczenia-uslug-droga-elektroniczna-3165"
                                                    target="_blank"
                                                >
                                                    {translations['regulations-of-services-electronic-name']}
                                                </a>{' '}
                                                {translations['and']}{' '}
                                                <a href="/polityka-prywatnosci" target="_blank">
                                                    {translations['privacy-policy-name']}
                                                </a>
                                                .
                                            </span>
                                        </div>
                                    </div>

                                    <div className="tickbox" style={{ marginBottom: '20px' }}>
                                        <div className="left">
                                            <input
                                                type="checkbox"
                                                required
                                                name="sm_form_consent_name_4437_ZGODA_2_VC"
                                                checked={
                                                    this.state.newsletterFormData.sm_form_consent_name_4437_ZGODA_2_VC
                                                }
                                                onChange={this.handleNewsletterCheckboxChange}
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="right">
                                            <span>{translations['i_agree_to_receive_commercial_information']}</span>
                                        </div>
                                    </div>

                                    <div>
                                        <button className="btn_vc" type="submit">
                                            {translations['newsletter-save-btn']}
                                        </button>
                                    </div>
                                </form>
                            )}

                            {this.state.newsletterFormResult && (
                                <div id="form_result">{this.state.newsletterFormResult}</div>
                            )}
                        </div>

                        {this.state.isSecondCalculation ? (
                            <div>
                                <span className="calendar-error">{translations['error-overwriting-session']}</span>
                                <a href={activeCalculationUrl} className="btn_vc btn_vc--turquoise-shadow">
                                    {translations['booking-action-return']}
                                </a>
                                <button
                                    className="btn_vc"
                                    type="button"
                                    disabled={!canContinue}
                                    onClick={this.forceRedirect}
                                >
                                    {translations['booking-action-overwrite']}
                                </button>
                            </div>
                        ) : (
                            <a
                                id="btn_continue_booking"
                                href={canContinue ? this.generateCalculationUrl() : undefined}
                                className="btn_vc"
                                aria-disabled={!canContinue}
                                onClick={event => {
                                    if (!canContinue) {
                                        event.preventDefault()
                                    }
                                }}
                            >
                                {translations['booking-action-init']}
                            </a>
                        )}

                        <div className="btn_vc__description">{translations['booking-action-nonpayment']}</div>
                        <div>
                            {locale != 'pl' && (
                                <img
                                    height="36px"
                                    alt="BankTransfer"
                                    src={IcoBankTransfer}
                                    style={{ margin: '7px 5px' }}
                                />
                            )}
                            {locale == 'pl' && (
                                <img
                                    height="36px"
                                    alt="Przelew Bankowy"
                                    src={IcoBankTransferPl}
                                    style={{ margin: '7px 5px' }}
                                />
                            )}
                            <img height="36px" alt="Visa" src={IcoVisa} style={{ margin: '7px 5px' }} />
                            <img height="36px" alt="MasterCard" src={IcoMasterCard} style={{ margin: '7px 5px' }} />

                            {locale == 'pl' && (
                                <img height="36px" alt="Blik" src={IcoBlik} style={{ margin: '7px 5px' }} />
                            )}

                            <img height="31px" alt="PayPal" src={IcoPayPal} style={{ margin: '7px 5px' }} />
                            <img height="31px" alt="GooglePay" src={IcoGooglePay} style={{ margin: '7px 5px' }} />
                            <img height="31px" alt="ApplePay" src={IcoApplePay} style={{ margin: '7px 5px' }} />

                            {locale == 'pl' && (
                                <img height="31px" alt="PayPo" src={IcoPayPo} style={{ margin: '7px 5px' }} />
                            )}
                            {/*<img height="31px" alt="Klarna" src={IcoKlarna} style={{margin: "7px 5px"}} />*/}
                            {/* {(locale == 'pl') &&
                            <img height="28px" alt="Blik Płacę Później" src={IcoBlikPP} style={{margin: "7px 5px"}} />
                        } */}
                            {/* {(locale == 'pl') &&
                            <img height="31px" alt="TpayRaty" src={IcoTpayRaty} style={{margin: "7px 5px"}}/>
                        } */}

                            {/*<img height="31px" alt="Mybenefit" src={IcoMyBenefit} style={{margin: "7px 5px"}} />*/}
                        </div>
                    </div>
                )}
            </div>
        )
    }

    render() {
        const {
            isLoading,
            post_id
        } = this.state;

        const {from, to, daysOccupied} = this.state

        return <PrimaryBox heading={translations['calendar-heading-1']}>
            <div className="booking-calendar">
                {post_id &&
                <div className="booking-calendar__inner">
                    {this.state.unavailableReason &&
                    <div className="DayPicker__message DayPicker__message--warning">
                      <span>
                        <span className="DayPicker__icon DayPicker__icon--question"/>
                          {this.state.unavailableReason}
                      </span>
                    </div>
                    }
                    <div className="functionalModules">
                        <Calendar
                            ref={this.calendarRef}
                            post_id={this.state.post_id}
                            onDateSelected={this.handleDateSelected}
                            date={{from, to}}
                            onClear={() => this.handleClear()}
                            daysOccupied={daysOccupied}
                            locale={this.props.initData.locale}
                            nightsTotal={this.state.nightsTotal}
                        />
                        <CounterMultiple
                            onChange={this.handleCounterChange}
                            counters={this.getDefaultCounters()}
                            guestsLimit={this.props.initData.guestsLimit}
                            adultsLimit={this.props.initData.adultsLimit}
                            kidsLimit={this.props.initData.kidsLimit}
                            babiesLimit={this.props.initData.babiesLimit}
                        />
                    </div>
                    {this.state.isGuestsNumberValid === false && (
                        <span className="calendar-error calendar-error--box" role="alert">
                            {translations['error-invalid-guests-number']
                                .replace(
                                    ':limit',
                                    this.props.initData.guestsLimit
                                )
                                .replace(
                                    ':babies_limit',
                                    this.props.initData.babiesLimit
                                )}
                        </span>
                    )}
                    <div id="actions">
                        {this.renderActionButton()}
                    </div>
                </div>
                }
                {isLoading && <Loading text={translations['preloader-check']}/>}
            </div>
        </PrimaryBox>
    }
}
